import { cx } from '@linaria/core';
const defaultStyle = "d1w4eajo";
const variantStyle = {
  h1: "h9gd1ow",
  h2: "h1hypz34",
  'h3-strong': "h1f1kgmp",
  h3: "hyzhbwd"
};
export const Heading: React.FC<{
  variant: 'h1' | 'h2' | 'h3-strong' | 'h3';
  component: 'h1' | 'h2' | 'h3' | 'h4';
  children: React.ReactNode;
  fontSize?: 'md' | 'sm';
}> = props => {
  const Component = props.component;
  return <Component className={cx(defaultStyle, variantStyle[props.variant], props.fontSize === 'md' && 'text-md', props.fontSize === 'sm' && 'text-sm')}>
      {props.children}
    </Component>;
};

require("./Heading.linaria.module.css!=!../../../node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./Heading.tsx");